const currencyFmt = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
});

const exactCurrencyFmt = new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
});

const integerFmt = new Intl.NumberFormat('de-DE');

const percentFmt = new Intl.NumberFormat('de-DE', { style: 'percent', minimumFractionDigits: 1, maximumFractionDigits: 1 });

export function formatCurrency(amount: number): string {
    if (!Number.isFinite(amount)) return '--';
    return currencyFmt.format(amount);
}

// Ledger amounts carry cents, which formatCurrency rounds away.
export function formatCurrencyExact(amount: number): string {
    if (!Number.isFinite(amount)) return '--';
    return exactCurrencyFmt.format(amount);
}

export function formatInteger(value: number): string {
    if (!Number.isFinite(value)) return '--';
    return integerFmt.format(value);
}

/** @param share a fraction between 0 and 1 */
export function formatPercent(share: number): string {
    if (!Number.isFinite(share)) return '--';
    return percentFmt.format(share);
}

export function formatBytes(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    const units = ['KB', 'MB', 'GB', 'TB'];
    let value = bytes / 1024;
    let unit = 0;
    while (value >= 1024 && unit < units.length - 1) {
        value /= 1024;
        unit++;
    }
    return `${value.toFixed(value >= 100 ? 0 : 1)} ${units[unit]}`;
}
